export default "__VITE_ASSET__CYUBST3j__";